export const getPensions = (state) => state.pensions
export const getPensionTypes = (state) => state.types
